var s=["Contains","NotContains"],i=i=>s.includes(i);export{i as isCaseSensitive};
//# sourceMappingURL=isCaseSensitive.js.map